import ru from 'date-fns/locale/ru';

export const datePickerConfig = {
    calendarStartDay: 1, // Неделя начинается с понедельника
    locale: ru
} as const;

